import { render, staticRenderFns } from "./DetailsNotaAzienda.vue?vue&type=template&id=67dfcda4&scoped=true&"
import script from "./DetailsNotaAzienda.vue?vue&type=script&lang=ts&"
export * from "./DetailsNotaAzienda.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsNotaAzienda.vue?vue&type=style&index=0&id=67dfcda4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dfcda4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VRow})
